// Allowing wild card here as it will not compile otherwise
// eslint-disable-next-line no-restricted-syntax
import * as Localization from 'expo-localization';
import accountsStrings from 'features/accounts/localization/accountsStrings';
import advanceStrings from 'features/advance/localization/advanceStrings';
import authStrings from 'features/auth/localization/authStrings.en';
import cstVerifyStrings from 'features/auth/localization/cstVerifyStrings.en';
import believeString from 'features/believe/localization/believeString';
import billManagerStrings from 'features/billManager/localization/billManagerStrings';
import billSwitchStrings from 'features/billSwitch/localization/billSwitchStrings';
import cardManagementStringsEn from 'features/cardManagement/localization/cardManagementStrings.en';
import chatStringsEN from 'features/chat/localization/chatStrings.en';
import creditStrings from 'features/creditScore/localization/creditStrings';
import directDepositStringsEn from 'features/directDeposit/localization/directDepositStrings.en';
import feeBasedInstantTransferStrings from 'features/feeBasedInstantTransfer/localization/feeBasedInstantTransferStrings';
import forceUpdateStrings from 'features/forceUpdate/localization/forceUpdateStrings';
import getVaroAppStrings from 'features/getVaroApp/localization/getVaroAppStrings';
import homeScreenStrings from 'features/home/localization/homeScreenStrings';
import incentiveStrings from 'features/incentive/localization/incentiveStrings';
import vlocStrings from 'features/lineOfCredit/localization/vlocStrings';
import disclosuresStringEN from 'features/moveMoney/localization/disclosuresString.en';
import moveMoneyStringsEN from 'features/moveMoney/localization/moveMoneyStrings.en';
import myVaroStrings from 'features/myVaro/localization/myVaroStrings';
import onboardingStrings from 'features/onboarding/localization/onboardingStrings.en';
import verifyIdentityStrings from 'features/otp/challenges/VerifyIdentity/VerifyIdentityStrings.en';
import otpStringsEN from 'features/otp/localization/otpStrings.en';
import payLaterStrings from 'features/payLater/localization/payLaterStrings';
import payOverTimeStrings from 'features/payOverTime/localization/payOverTimeStrings';
import personalInfoStrings from 'features/personalInfo/localization/PersonalInfoTranslations';
import plaidStrings from 'features/plaid/localization/plaidStrings';
import rdcStringsEN from 'features/rdc/rdcStrings.en';
import reactivationStrings from 'features/reactivation/localization/reactivation.en';
import rewardsString from 'features/rewards/localization/rewardsString';
import signupStrings from 'features/signup/localization/signupStrings';
import spendBenefitsStrings from 'features/spendBenefits/localization/spendBenefitsStrings';
import suspiciousTransactionString from 'features/suspiciousTransaction/localization/suspiciousTransactionString';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import componentsStringsEN from 'shared/components/componentsStrings.en';
import debtSaleStrings from 'shared/components/DebtSale/localization/debtSaleStrings';
import lendingStringsEn from 'shared/components/lending/localization/lendingStrings.en';
import showMoreAccordianStrings from 'shared/components/ShowMoreAccordian/ShowMoreAccordionStrings.en';
import lineChartStringsEn from 'shared/components/SmartViews/Charts/LineChart/lineChartString.en';
import CalendarPickerStringsEN from 'shared/components/vxl/CalendarPicker/CalendarPickerStrings.en';
import fullScreenLoadingStrings from 'shared/components/vxl/loading/FullScreenLoading/FullScreenLoadingStrings.en';
import { sharedErrorStringsEN } from 'shared/hooks/errorFormatters/sharedErrorStrings.en';
import plaidV2Strings from 'shared/hooks/usePlaidV2/localization/plaidStrings';
import ButtonStringsEN from 'shared/localization/localizedStrings/ButtonStrings.en';
import patternsStrings from 'shared/patterns/localization/patternsStrings';

import en from './localizedStrings/en.json';
import fr from './localizedStrings/fr.json';
import HorizontalAccountCardStringsEN from './localizedStrings/HorizontalAccountCardStrings.en';
import mapsStringsEn from './localizedStrings/maps/mapsStrings.en';
import routeNotFoundStringsEn from './localizedStrings/routeNotFoundStrings.en';

const resources = {
  en: {
    ...en,
    accounts: accountsStrings.en,
    personalInfoStrings: personalInfoStrings.en,
    moveMoney: moveMoneyStringsEN,
    chatStrings: chatStringsEN,
    sharedError: sharedErrorStringsEN,
    rdc: rdcStringsEN,
    believe: believeString.en,
    advance: advanceStrings.en,
    lineChart: lineChartStringsEn,
    fullScreenLoading: fullScreenLoadingStrings,
    vloc: vlocStrings.en,
    forceUpdate: forceUpdateStrings.en,
    horizontalAccountCard: HorizontalAccountCardStringsEN,
    componentsStrings: componentsStringsEN,
    calendar: CalendarPickerStringsEN,
    rewards: rewardsString.en,
    otp: otpStringsEN,
    myVaro: myVaroStrings.en,
    buttons: ButtonStringsEN,
    signup: signupStrings.en,
    maps: mapsStringsEn,
    home: homeScreenStrings.en,
    showMoreAccordian: showMoreAccordianStrings,
    reactivation: reactivationStrings,
    creditScore: creditStrings.en,
    directDeposit: directDepositStringsEn,
    feeBasedInstantTransfer: feeBasedInstantTransferStrings.en,
    lending: lendingStringsEn,
    debtSale: debtSaleStrings.en,
    suspiciousTransaction: suspiciousTransactionString.en,
    onboarding: onboardingStrings,
    routeNotFound: routeNotFoundStringsEn,
    auth: authStrings,
    cstVerify: cstVerifyStrings,
    patterns: patternsStrings.en,
    disclosures: disclosuresStringEN,
    cardManagement: cardManagementStringsEn,
    verifyIdentity: verifyIdentityStrings,
    payOverTime: payOverTimeStrings.en,
    payLater: payLaterStrings.en,
    billManager: billManagerStrings.en,
    billSwitch: billSwitchStrings.en,
    getVaroApp: getVaroAppStrings.en,
    plaidStrings: plaidStrings.en,
    plaidV2Strings: plaidV2Strings.en,
    spendBenefits: spendBenefitsStrings.en,
    incentive: incentiveStrings.en,
  },
  fr,
};

const getLangCode = () => {
  const code = Localization.getLocales().shift();
  return code?.languageCode ?? 'en';
};

void i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  resources,
  lng: getLangCode(), // Default language
  interpolation: {
    escapeValue: false, // React already escapes values
  },
  fallbackLng: {
    default: ['en'],
  },
});

export default i18n;
